var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "customer-form" }, [
    _c("h3", [_vm._v("Kundendaten")]),
    _vm._v(" "),
    _c("div", { staticClass: "row mt-3" }, [
      !_vm.isGenderCompany
        ? _c(
            "div",
            { staticClass: "col-md-6" },
            [
              _c("csp-form-group-radio", {
                attrs: {
                  form: _vm.customerForm,
                  options: _vm.genderOptions,
                  property: "gender",
                  required: "",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isGenderPerson
        ? _c(
            "div",
            { staticClass: "col-md-6" },
            [
              _c("csp-form-group-input", {
                attrs: {
                  form: _vm.customerForm,
                  property: "companyName",
                  required: _vm.isGenderCompany,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "w-100" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-md-6" },
        [
          _c("csp-form-group-input", {
            attrs: {
              form: _vm.customerForm,
              "label-property": _vm.firstNameLabel,
              "potentially-required": _vm.isFleetOrMajorCustomer,
              property: "firstName",
              required: _vm.isNameRequired,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-md-6" },
        [
          _c("csp-form-group-input", {
            attrs: {
              form: _vm.customerForm,
              "label-property": _vm.lastNameLabel,
              "potentially-required": _vm.isFleetOrMajorCustomer,
              property: "lastName",
              required: _vm.isNameRequired,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-md-6" },
        [
          _c("csp-form-group-input", {
            attrs: { form: _vm.customerForm, property: "street", required: "" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-6" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-md-4" },
            [
              _c("csp-form-group-input", {
                attrs: {
                  form: _vm.customerForm,
                  property: "postalCode",
                  required: "",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-8" },
            [
              _c("csp-form-group-input", {
                attrs: {
                  form: _vm.customerForm,
                  property: "place",
                  required: "",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-md-6" },
        [
          _c("csp-form-group-input", {
            attrs: {
              form: _vm.customerForm,
              "potentially-required": _vm.isFleetOrMajorCustomer,
              property: "phoneGeneric",
              required: "",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-md-6" },
        [
          _c("csp-form-group-input", {
            attrs: {
              form: _vm.customerForm,
              "potentially-required": _vm.isFleetOrMajorCustomer,
              property: "email",
              required: _vm.isFleetOrMajorCustomer,
              type: "email",
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12 mt-3" }, [
      _c("h3", [_vm._v("Wie können wir Sie am besten erreichen?")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }